// extracted by mini-css-extract-plugin
export default {"footer_links":"Footer_footer_links__mMY5e","footer_link":"Footer_footer_link__Nx85F"};